import React from 'react';
import LoaderSVG from '../../../svgs/svg-loader.svg';

const Loader = () => <img src={LoaderSVG} alt="loading" className={`loading`} />;

export default Loader;
